import { parseDate } from '../services/datesService';

import appointmentTypesResource from './appointmentTypesResource';
import createResource from './createResource';
import facilitiesResource from './facilitiesResource';
import patientsResource from './patientsResource';
import providersResource from './providersResource';
import { Appointment } from './types';

const appointmentsResource = createResource<Appointment>({
  key: 'appointments',
  url: '/appointments',
  fetchPageUrl: '/appointments/crudList',
  fetchListUrl: '/appointments/crudList',
  hasFetchBulkSupport: true,
  lookups: {
    facility: facilitiesResource,
    patient: patientsResource,
    provider: providersResource,
    type: appointmentTypesResource,
  },
  processStrategy: (data) => ({
    ...data,
    $date: parseDate(data.date),
    // WORKAROUND Ensure that the `type` field exists, even if it's undefined,
    // because API is not returning it in some cases.
    // More info: https://github.com/lumahealthhq/web-app/pull/2241#issuecomment-563951206
    type: data.type,
    $toString: `[${data.status}] ${data.$toString}`,
  }),
});

export default appointmentsResource;
